/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserEmailDeliveryLogRequest} from '../models/UserEmailDeliveryLogRequest';
import type {UserEmailDeliveryLogResponse} from '../models/UserEmailDeliveryLogResponse';

export interface GetUserEmailHistory$Request {
    userEmailDeliveryLogRequest: UserEmailDeliveryLogRequest;
}

export interface GetUserEmailHistory$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserEmailHistoryRequest = createAction<PayloadData<void, GetUserEmailHistory$Request>>('USERS_EMAILS_HISTORY__GET_USER_EMAIL_HISTORY__REQUEST');
export const getUserEmailHistorySuccess = createAction<PayloadData<UserEmailDeliveryLogResponse, GetUserEmailHistory$Request>>('USERS_EMAILS_HISTORY__GET_USER_EMAIL_HISTORY__SUCCESS');
export const getUserEmailHistoryFailure = createAction<PayloadData<Error, GetUserEmailHistory$Request, true>>('USERS_EMAILS_HISTORY__GET_USER_EMAIL_HISTORY__FAILURE');

export const getUserEmailHistoryActions = [
    getUserEmailHistoryRequest,
    getUserEmailHistorySuccess,
    getUserEmailHistoryFailure
] as const;

/**
 * @param {UserEmailDeliveryLogRequest} meta.userEmailDeliveryLogRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserEmailHistory = (meta: GetUserEmailHistory$Request, config?: GetUserEmailHistory$Config) => {
    return {
        CALL_API: {
            types: getUserEmailHistoryActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/email-delivery-logs`,
            TRANSPORT_REQUEST_BODY: meta.userEmailDeliveryLogRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

